(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fightgear-help-nav"] && !Shopify.designMode) return;
  try {
    function fightgearHelpActiveLink() {
  document.querySelectorAll('.fg-help-nav').forEach((nav) => {
    const list = nav.querySelector('ul');
    const active = nav.querySelector('[aria-current="page"]');
    if (!list || !active || list.scrollWidth <= list.clientWidth) return;
    list.scrollLeft += active.getBoundingClientRect().left - list.getBoundingClientRect().left - (list.clientWidth - active.clientWidth) / 2;
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fightgearHelpActiveLink); else fightgearHelpActiveLink();
document.addEventListener('shopify:section:load', fightgearHelpActiveLink);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fightgear-policy"] && !Shopify.designMode) return;
  try {
    function fightgearPolicyNavigation() {
  document.querySelectorAll('.fg-policy').forEach((section) => {
    const body = section.querySelector('.shopify-policy__body');
    const contents = section.querySelector('.fg-policy__toc');
    if (!body || !contents || contents.dataset.ready) return;
    contents.dataset.ready = 'true';
    const terms = section.classList.contains('fg-policy--terms');
    const headings = terms ? Array.from(body.querySelectorAll('strong')).filter((node) => /^(OVERVIEW|SECTION \d+\s*-)/.test(node.textContent.trim())) : Array.from(body.querySelectorAll('h2,h3')).filter((node) => getComputedStyle(node).display !== 'none');
    const list = contents.querySelector('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `fg-policy-topic-${index + 1}`;
      heading.tabIndex = -1;
      if (terms) { heading.setAttribute('role', 'heading'); heading.setAttribute('aria-level', '2'); }
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      const title = heading.textContent.trim();
      link.textContent = terms ? title.replace(/^SECTION \d+\s*-\s*/, '').toLowerCase().replace(/^./, (char) => char.toUpperCase()) : title;
      item.append(link); list.append(item);
    });
    if (headings.length) { contents.hidden = false; contents.open = window.matchMedia('(min-width:990px)').matches; }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fightgearPolicyNavigation); else fightgearPolicyNavigation();
  } catch(e) { console.error(e); }
})();

})();
